import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'
import { Topic } from 'types/certification'

const HookList = React.lazy(() => loadComponent('certification', 'HookList'))

const StyledButton = styled(Button)`
    float: right;
`

const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function CertificateHookIndex() {
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const canCreate = usePermission('certification.hook.create', { academy: academy?._id! })
    const canDelete = usePermission('certification.hook.delete', { academy: academy?._id! })

    const onSelect = useCallback(
        (topic: Topic) => {
            navigate(topic._id + '/update')
        },
        [navigate],
    )

    const onCreate = useCallback(() => navigate('new'), [navigate])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Zertifikat Automation</StyledHeadingText>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
            </StyledHeaderContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Zertifikat Automationen gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Zertifikat Automationen zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <>
                    <HookList academyId={academy?._id} onSelect={onSelect} canDelete={canDelete} />
                </>
            )}
        </RouteContainer>
    )
}
